<template>
  <div id="swiper-img-two" class="swiper-container">
    <div class="swiper-wrapper">
      <div v-for="(img,index) in imgs" id="banner" :key="index" class="swiper-slide">
        <img :src="img" alt="轮播图banner">
      </div>

    </div>
    <!-- 如果需要分页器 -->
    <div class="swiper-pagination" />
    <!-- 如果需要滚动条 -->
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
export default {

  props: {
    imgs: {
      type: Array,
      default: null
    }
  },
  data () {
    return {

    }
  },
  mounted () {
    this.initSwiper()
  },
  methods: {
    initSwiper () {
      const mySwiper = new Swiper('#swiper-img-two', {
        autoplay: true,
        loop: true,
        centeredSlides: true,
        delay: 5000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: function (swiper) {
          swiper.update()
          mySwiper.startAutoplay()
          mySwiper.reLoop()
        }
      })
      console.log(mySwiper)
      console.log('imgs____', this.imgs)
    }
  }
}
</script>

<style scoped>
.swiper-container {
height: 100%;
width: 100%;
}
#banner{
   height: 100%;
   width: 100%;
}
#banner img{
  width: 100%;
  height: 100%;
}
</style>
